export default "__VITE_ASSET__BhpjsQDY__"